export interface SaRaState {
  raTemplate: any;
  likelihood: any;
  impactRating: any;
  vulnerabilities: any;
  riskVelocity: any;
  riskRating: any;
}

export const initialState: SaRaState = {
  raTemplate: {},
  likelihood: [],
  impactRating: [],
  vulnerabilities: [],
  riskVelocity: [],
  riskRating: [],
};
